export default function({ state, commit, dispatch, rootState }, { provider, patient, recordObj}) {
    const sendFileObj = {
        ...recordObj,
        created_by: rootState.auth.id
    }
    return dispatch('post', {
        url: '/provider/' + (state.id ? state.id : provider) + '/patient/' + patient + '/record',
        data: sendFileObj
    }, {
        root: true
    })
    .then((record) => {
        commit('updatePatient', {
            id: patient,
            record: [record]
        })
    })
    .catch((error) => {
        console.log(error)
        throw error
    })
}
